import { render, staticRenderFns } from "./zxVvTable.vue?vue&type=template&id=250e62db&scoped=true&"
import script from "./zxVvTable.vue?vue&type=script&lang=js&"
export * from "./zxVvTable.vue?vue&type=script&lang=js&"
import style0 from "./zxVvTable.vue?vue&type=style&index=0&id=250e62db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e62db",
  null
  
)

export default component.exports